// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type ScoreFragment = { id: string, username: string | undefined, points: string | undefined, position: number | undefined, isMyScore: boolean | undefined, canClaimPrize: boolean | undefined };

export const ScoreFragmentDoc = gql`
    fragment ScoreFragment on CasinoTournamentsPublicScore {
  id
  username
  points
  position
  isMyScore
  canClaimPrize
}
    `;